import React from 'react';
import { connect } from 'react-redux'
import { Spinner } from "react-bootstrap";

function InPlaceLoader(props) {
    return (
        <div className={' position-fixed in-location-loader  align-item-center justify-content-center m-auto ' + props.className}>
            <div className={"m-auto d-flex align-self-center"}>
                <span className={"color-white ml-2 bold"}>{props.text}</span>
                <Spinner className={"color-white"} animation="border" />
            </div>
        </div>
    )
}

export default connect()(InPlaceLoader);